import { ScreenPlayingOptionType } from "@hooks/useScreens/types";
import AssetPlayer from "./AssetPlayer";
import LayoutPlayer from "./LayoutPlayer";
import PlaylistPlayer from "./PlaylistPlayer";
import VideoPlayer from "./VideoPlayer";
import AnimatingGradientBackground from "./components/AnimatingGradientBackground";
import { SignageContentPlayerProvider, SignageContentPlayerProviderProps } from "./hooks/ContentPlayerProvider";
import { VideoPlayerRefProvider } from "./hooks/useVideoPlayerRef";

export function SignageContentPlayer({ opt, renderContent = false, renderVideo = true, ...props }: { opt: ScreenPlayingOptionType } & SignageContentPlayerProviderProps & { renderContent?: boolean; renderVideo?: boolean }) {
  return (
    <SignageContentPlayerProvider {...props}>
      <VideoPlayerRefProvider>
        {opt?.type === "playlist" ? (
          // must be on top, as layout, asset, video exist in this object too
          <PlaylistPlayer playlist={opt} />
        ) : opt.type === "layout" || opt.type === "template" ? (
          <LayoutPlayer layoutInfo={opt} renderContent={renderContent} muted={false} />
        ) : opt.type === "asset" ? (
          <AssetPlayer asset={opt} />
        ) : opt.type === "video" ? (
          <VideoPlayer loop url={opt.url ?? ""} renderVideo={renderVideo} {...props} />
        ) : (
          <div
            className={`relative z-0 flex h-full w-full flex-col items-center justify-center gap-8 overflow-hidden text-[#3d2b24] font-exo`}
            aria-hidden="true"
          >
            <h1 aria-hidden="true" className="text-[calc(4px+7vw)] font-semibold">
              Hi there 👋
            </h1>
            <h2 aria-hidden="true" className="text-center text-[calc(4px+3vw)]">
              Waiting for you to select a design from <br /> your account to
              display here...
            </h2>
            <AnimatingGradientBackground className="absolute -z-10 h-full w-full opacity-50" />
          </div>
        )}
      </VideoPlayerRefProvider>
    </SignageContentPlayerProvider>
  )
}
